"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lisk_cryptography_1 = require("@liskhq/lisk-cryptography");

var _1_second_signature_transaction_1 = require("./1_second_signature_transaction");

var constants_1 = require("./constants");

var utils_1 = require("./utils");

var validateInputs = function validateInputs(_ref) {
  var secondPassphrase = _ref.secondPassphrase;

  if (typeof secondPassphrase !== 'string') {
    throw new Error('Please provide a secondPassphrase. Expected string.');
  }
};

exports.registerSecondPassphrase = function (inputs) {
  validateInputs(inputs);
  var passphrase = inputs.passphrase,
      secondPassphrase = inputs.secondPassphrase;

  var _lisk_cryptography_1$ = lisk_cryptography_1.getKeys(secondPassphrase),
      publicKey = _lisk_cryptography_1$.publicKey;

  var transaction = Object.assign({}, utils_1.createBaseTransaction(inputs), {
    type: 1,
    fee: constants_1.SIGNATURE_FEE.toString(),
    asset: {
      signature: {
        publicKey: publicKey
      }
    }
  });

  if (!passphrase) {
    return transaction;
  }

  var secondSignatureTransaction = new _1_second_signature_transaction_1.SecondSignatureTransaction(transaction);
  secondSignatureTransaction.sign(passphrase);
  return secondSignatureTransaction.toJSON();
};